import axios, { CancelToken } from 'axios';
import { getToken } from '../../../token';
import { urlHttpGov } from '../../../request/urls';
import { IConfigPlano, ICreateConfigPlanoPayload, IUpdateConfigPlanoPayload } from '../../../../pages/Propostas/interface';

class ConfigPlanoPropostaService {
    private readonly baseURL = `${urlHttpGov}/proposta-comercial/config-plano`;

    private getHeaders() {
        return {
            Authorization: `Bearer ${getToken()}`
        };
    }

    async getAll(signal?: CancelToken): Promise<IConfigPlano[]> {
        const { data } = await axios.get(`${this.baseURL}`, {
            headers: this.getHeaders(),
            cancelToken: signal
        });
        return data;
    }

    async getById(id: number | string, signal?: CancelToken): Promise<IConfigPlano> {
        const { data } = await axios.get(`${this.baseURL}/${id}`, {
            headers: this.getHeaders(),
            cancelToken: signal
        });
        return data;
    }

    async create(payload: ICreateConfigPlanoPayload): Promise<IConfigPlano> {
        const { data } = await axios.post(`${this.baseURL}`, payload, {
            headers: this.getHeaders()
        });
        return data;
    }

    async update(id: number | string, payload: IUpdateConfigPlanoPayload): Promise<IConfigPlano> {
        const { data } = await axios.put(`${this.baseURL}/${id}`, payload, {
            headers: this.getHeaders()
        });
        return data;
    }

    async delete(id: number | string): Promise<void> {
        await axios.delete(`${this.baseURL}/${id}`, {
            headers: this.getHeaders()
        });
    }
}

export default new ConfigPlanoPropostaService();
